import { combineReducers } from 'redux';

import ConnectTypes from './types';

export const connectReducer = combineReducers({
  listMyConnects: ConnectTypes.listMyConnects.getReducer(),
  listConnect: ConnectTypes.listConnect.getReducer(),
  listActionsConnect: ConnectTypes.listActionsConnect.getReducer(),
  saveConnect: ConnectTypes.saveConnect.getReducer(),
  updateConnect: ConnectTypes.updateConnect.getReducer(),
  saveAction: ConnectTypes.saveAction.getReducer(),
  listTriggers: ConnectTypes.listTriggers.getReducer(),
  listConnectProduct: ConnectTypes.listConnectProduct.getReducer(),
  listConnectOptions: ConnectTypes.listConnectOptions.getReducer(),
  loadConnect: ConnectTypes.loadConnect.getReducer(),
  loadAction: ConnectTypes.loadAction.getReducer(),
  updateAction: ConnectTypes.updateAction.getReducer(),
  changeStatusConnect: ConnectTypes.changeStatusConnect.getReducer(),
  getActionFields: ConnectTypes.getActionFields.getReducer(),
  validateMailChimp: ConnectTypes.validateMailChimp.getReducer(),
  validateAweber: ConnectTypes.validateAweber.getReducer(),
  validateInfusion: ConnectTypes.validateInfusion.getReducer(),
});
